import React from 'react';

import { currencyList } from '@dashboard/services/currency';

import { SelectField } from '../Select';

const CurrencySelector = ({ name, ...props }) => {
  const options = Object.keys(currencyList).map(key => ({
    value: currencyList[key].code,
    label: currencyList[key].code.toUpperCase(),
  }));

  return <SelectField name={name} options={options} {...props} />;
};

export default CurrencySelector;
